import React, { useEffect, useState } from 'react';
import '../styling/exam.css';
import { useNavigate, Navigate } from 'react-router-dom';
import axios from 'axios';

export default function Exam() {
    const [isloading, setisloading] = useState(false);
    const [change, setchange] = useState(0);
    const navigate = useNavigate();
    const [redcolor, setredcolor] = useState(false);
    const [greencolor, setgreencolor] = useState(false);
    const [count, setcount] = useState(0);
    const [score, setscore] = useState(0);
    const [questions, setquestions] = useState(JSON.parse(localStorage.getItem('oponent_data')));
    const ques = questions[count];
    const clickhandler = async (id) => {
        if (id.toString() === ques.answer) {
            setgreencolor(true)
            setscore(prev => prev + 1);
            const timer = setTimeout(() => {
                setgreencolor(false);
            }, 100);
            return () => clearTimeout(timer);
        }
        else {
            setscore(prev => prev);
            setchange(prev => prev + 1);
            setredcolor(true);
            const timer = setTimeout(() => {
                setredcolor(false);
            }, 100);
            return () => clearTimeout(timer);
        }
    }
    useEffect(() => {
        if (count === 0) {
            setcount(prev => prev - 1);
        }
    }, []);
    useEffect(() => {
        const scoreenter = async () => {
            if (count < 8) {
                setcount(prev => prev + 1);
            }
            else {
                setisloading(true);
                await axios.post(`https://quiz-backend-mqz8.onrender.com/quiz-score`, { userid: localStorage.getItem('oponent_userid'), name: localStorage.getItem('user_exam_name'), score: score });
                localStorage.setItem('user_score', `${score}`);
                localStorage.setItem(`${localStorage.getItem('oponent_userid')}`, `${score}`);
                setcount(prev => prev);
                setisloading(false);
                navigate('/score');
            }
        }
        scoreenter();
    }, [score, change]);
    if (isloading) {
        return (
            <div className="loadanimation">
                Loading...
            </div>
        )
    }
    return (
        <>
            {localStorage.getItem(`${localStorage.getItem('oponent_userid')}`) ? <Navigate to='/score' /> :
                <div className='exam'>
                    <div className="ansbox">
                        <div className="quesnum">Question {count + 1} of 9</div>
                        <div className="quizquestion">{ques.sendquestion}</div>
                        <div className={`quizoptions ${redcolor ? "red" : ""} ${greencolor ? "green" : ""}`}>
                            <div className="quizops" onClick={() => clickhandler(0)}>{ques.sendoptions.opt0}</div>
                            <div className="quizops" onClick={() => clickhandler(1)}>{ques.sendoptions.opt1}</div>
                            <div className="quizops" onClick={() => clickhandler(2)}>{ques.sendoptions.opt2}</div>
                            <div className="quizops" onClick={() => clickhandler(3)}>{ques.sendoptions.opt3}</div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
